import { BoxProps, Field, Input, Text } from '@workwhile/ui'
import { formatCurrency } from 'lib/string'
import { ChangeEvent, useState } from 'react'
import { useController, useFormContext } from 'react-hook-form'

function sanitizeCurrencyInput(value: string): string {
  const withoutInvalidChars = value.replace(/[^0-9.]/g, '')
  const [whole = '', ...fractionParts] = withoutInvalidChars.split('.')
  if (fractionParts.length === 0) {
    return whole
  }

  return `${whole}.${fractionParts.join('').slice(0, 2)}`
}

/**
 * Formats input as currency on blur
 */
export const TipAmountInput = ({
  title = 'Amount',
  name = 'amount',
  ...boxProps
}: {
  title?: string
  name?: string
} & BoxProps) => {
  const [isFocused, setIsFocused] = useState(false)
  const { control } = useFormContext()
  const { field, fieldState } = useController({
    name,
    control,
  })

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = sanitizeCurrencyInput(event.target.value)
    field.onChange(nextValue === '' ? null : nextValue)
  }

  const handleBlur = () => {
    setIsFocused(false)
    if (
      field.value !== null &&
      field.value !== undefined &&
      field.value !== ''
    ) {
      const numericValue = Number(field.value)
      if (!Number.isNaN(numericValue)) {
        field.onChange(numericValue)
      }
    }
    field.onBlur()
  }

  const displayValue = (() => {
    if (isFocused) {
      return field.value ?? ''
    }
    if (
      field.value === null ||
      field.value === undefined ||
      field.value === ''
    ) {
      return ''
    }
    const numericValue = Number(field.value)
    if (Number.isNaN(numericValue)) {
      return String(field.value)
    }
    return formatCurrency(numericValue)
  })()

  return (
    <Field
      label={<Text fontWeight="bold">{title}</Text>}
      error={fieldState.error?.message}
      {...boxProps}
    >
      <Input
        type="text"
        inputMode="decimal"
        placeholder="e.g. 10.00"
        name={field.name}
        ref={field.ref}
        value={displayValue}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={handleBlur}
      />
    </Field>
  )
}
